import type { IconSvgObject } from './types';

const UserWarning02Icon: IconSvgObject = [
  ["circle", { cx: "11.5", cy: "7.5", r: "3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 6V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 13V13.01", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 20V16.9852C18 16.364 17.7184 15.7658 17.1838 15.4494C15.6574 14.546 13.6714 14 11.5 14C9.32863 14 7.34261 14.546 5.81618 15.4494C5.28162 15.7658 5 16.364 5 16.9852V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default UserWarning02Icon;
